<div *ngIf="!useNative" class="input">
    <div class="position-wrapper">
        <img src="/content/images/Calendar.svg" class="input-image-calendar" (click)="picker.open()" *ngIf="withImage">
        <input matInput [matDatepicker]="picker" class="input-component" [formControl]="dateControl" [placeholder]="placeholder" [min]="minDate" [max]="maxDate" (blur)="onBlur()" (click)="picker.open()" [class.input-invalid]="invalid">
    </div>
    <mat-datepicker [touchUi]="touchUi" #picker></mat-datepicker>
</div>

<div *ngIf="useNative" class="input native-picker">
    <div class="position-wrapper">
        <input type="date" class="input-component" [formControl]="dateControl" [placeholder]="placeholder" (blur)="onBlur()">
    </div>
</div>
